import { render, staticRenderFns } from "./LoadingAnimation.vue?vue&type=template&id=6f85f1d8&scoped=true&"
import script from "./LoadingAnimation.vue?vue&type=script&lang=js&"
export * from "./LoadingAnimation.vue?vue&type=script&lang=js&"
import style0 from "./LoadingAnimation.vue?vue&type=style&index=0&id=6f85f1d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85f1d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f85f1d8')) {
      api.createRecord('6f85f1d8', component.options)
    } else {
      api.reload('6f85f1d8', component.options)
    }
    module.hot.accept("./LoadingAnimation.vue?vue&type=template&id=6f85f1d8&scoped=true&", function () {
      api.rerender('6f85f1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LoadingAnimation.vue"
export default component.exports